import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { monetateActions } from '../redux/monetate/actions/MonetateActions.creators';
const MonetateContainer = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(monetateActions.init());
    }, []);
    return null;
};
export default MonetateContainer;
